import { Reveal } from "./Reveal";
import { useSinkRef } from "../utils/sink";

export const SectionHead = ({ chapter, eyebrow, title, lede, align = "left", dark = false }) => {
  const sinkRef = useSinkRef();
  return (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <Reveal>
      <p className={`eyebrow flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        {chapter && (
          <span className="font-mono text-xs text-gold">{chapter}</span>
        )}
        <span className="h-px w-8 bg-ink/25" aria-hidden="true" />
        <span className={dark ? "!text-gold-soft" : ""}>{eyebrow}</span>
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 ref={sinkRef} className="depth-3d mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] text-ink">
        {title}
      </h2>
    </Reveal>
    {lede && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/65">
          {lede}
        </p>
      </Reveal>
    )}
  </div>
  );
};
